import React from 'react';
import cx from 'classnames';
import './Section.scss';
import Button from './Button';

const Section = ({
  children,
  className,
  title,
  subTitle,
  button,
  paddingTop36,
  topBottomPaddingOff,
}) => (
  <div
    className={cx({
      section: true,
      [className]: className,
      'section--padding-top-36': paddingTop36,
      'section--no-top-bottom-padding': topBottomPaddingOff,
    })}
  >
    {subTitle && (
      <label data-sal="slide-up" data-sal-easing="ease" className="label">
        {subTitle}
      </label>
    )}
    {title && button && (
      <div className="section__button-title-container">
        {title && (
          <h2 className="section__title" data-sal="slide-up" data-sal-easing="ease">
            {title}
          </h2>
        )}
        {button && (
          <div data-sal="slide-up" data-sal-easing="ease">
            <Button className="section__button" to={button.url} variant="secondary">
              {button.text}
            </Button>
          </div>
        )}
      </div>
    )}
    {children}
  </div>
);

export default Section;
